import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { OUTLAW_QUERY_PARAMS } from '@outlaw/core';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { PostService } from '../services/api/post.service';
import { ExternalPostNavigationService } from '../services/navigation/external-post-navigation.service';

export interface ExternalPostRedirectConfig {
  skipAuth?: boolean;
  fallbackRoute: string;
}

export const externalPostRedirectResolver: (config: ExternalPostRedirectConfig) => ResolveFn<boolean> =
  config =>
  route => {
    const postService = inject(PostService);
    const externalPostNavService = inject(ExternalPostNavigationService);
    const router = inject(Router);

    const postId =
      route.queryParamMap.get(OUTLAW_QUERY_PARAMS.filmID) ||
      route.queryParamMap.get(OUTLAW_QUERY_PARAMS.postId) ||
      route.queryParamMap.get(OUTLAW_QUERY_PARAMS.post_id);

    if (!postId) {
      router.navigate([config.fallbackRoute]);
      return of(false);
    }

    return postService.getPost(postId, { skipAuth: config.skipAuth }).pipe(
      switchMap(post => postService.enrichWithLikesInfo([post])),
      map(([post]) => post),
      tap(post => {
        const url = externalPostNavService.getExternalPostUrl(post);
        if (url) {
          window.location.href = url;
        } else {
          router.navigate([config.fallbackRoute]);
        }
      }),
      map(() => true),
      catchError(() => {
        router.navigate([config.fallbackRoute]);
        return of(false);
      }),
    );
  };
